import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TimeEndedPopup({
  setloaderType,
  addMediumQueue,
  resetTimer,
  setHowManyTimes,
  from,
  appoinmentId
}) {
  const { t } = useTranslation("clientLive");
  const navigate = useNavigate();
  // const { id  } = useSelector((state) => state.user.user);

  const navigatePage = () => {
    window.loadModal2("#TimeEndedPopup", "hide");
    setTimeout(() => {
      if (from == "backfill") {
        navigate("/appointment")
        // navigate(`/appointments?from=backfill&appointment_id=${appoinmentId}`);
      } else {
        navigate("/appointment");
      }
    }, 100);
  };
  const resetTimerQueue = () => {
    window.loadModal2("#TimeEndedPopup", "hide");
    setHowManyTimes(0);
    setTimeout(() => {
      // addMediumQueue()
      // resetTimer()
    }, 100);
  };
  return (
    <div>
      <div
        id="TimeEndedPopup"
        class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-lg modal-dialog-preview text-center">
          <div class="modal-content ">
            <div className="no-app-fount-box">
              <p className="font-size-18">
                {t("backfill.timeEnded.noMatch")}
              </p>

              <br />
              <p className="font-size-18">
                {t("backfill.timeEnded.continueOrSelect")}
              </p>
              <div className="d-flex align-items-center justify-content-around">
                <div
                  onClick={resetTimerQueue}
                  className="width-260-px white-border pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                >
                  {t("backfill.timeEnded.continueWaiting")}
                </div>
                <div
                  onClick={navigatePage}
                  className="width-260-px white-bg-btn pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                >
                  {t("backfill.timeEnded.selectFuture")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
